import Default from "./DebounceValue";
export * from "./DebounceValue";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DebounceValue/index.ts